import React from "react";
import { Home, PlusCircleIcon, Truck, User } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
const AgentBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
const user = JSON.parse(localStorage.getItem("user"));
const role = user?.role;

  const tabs = [
    { name: "Home", icon: Home, path: "/agent/agent-dashboard" },
    { name: "Deliveries", icon: Truck, path: "/agent/deliveries-history" },
     ...(role === "coAdmin"
    ? [{ name: "Create Order", icon: PlusCircleIcon, path: "/agent/create-order" }]
    : []),
    { name: "Profile", icon: User, path: "/profile" },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 w-full h-[76px] bg-white border-t border-gray-200 shadow-[0_-2px_8px_rgba(0,0,0,0.08)] flex justify-around items-end pb-2 z-50">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = location.pathname.startsWith(tab.path);

        return (
          <button
            key={tab.name}
            className="flex flex-col items-center justify-center flex-1 h-full py-2 px-2 transition-all duration-200 group"
            onClick={() => navigate(tab.path)}
          >
            <div className={`transition-all duration-200 ${
              isActive 
                ? "text-blue-900 bg-blue-50 p-2 rounded-lg" 
                : "text-gray-600 p-2 group-hover:bg-gray-100 rounded-lg"
            }`}>
              <Icon
                className={`w-6 h-6 ${
                  isActive ? "stroke-[2.5]" : "stroke-[2]"
                }`}
              />
            </div>
            <span
              className={`text-xs mt-1 font-medium transition-colors duration-200 ${
                isActive 
                  ? "text-blue-900 font-semibold" 
                  : "text-gray-600"
              }`}
            >
              {tab.name}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default AgentBottomNav;